import { FormattedMessage } from 'react-intl'
import styled, { useTheme } from 'styled-components'
import Loader from '../loader/Loader'

export interface DropdownSuggestion<T> {
  icon?: JSX.Element
  label: string
  item: T
}
interface DropdownProps<T> {
  suggestions: DropdownSuggestion<T>[]
  onSelect: (suggestion: T) => void
  loading?: boolean
}

const Dropdown = <T extends {}>(props: DropdownProps<T>): React.ReactElement<any, any> => {
  const { suggestions, onSelect, loading } = props
  const theme = useTheme()

  if (loading) {
    return (
      <Container>
        <LoaderContainer>
          <Loader color={theme.color.primary} size={20} />
        </LoaderContainer>
      </Container>
    )
  }

  if (suggestions.length === 0) {
    return (
      <Container>
        <NoResultText>{<FormattedMessage id="DropOffLocation.search.noResult" />}</NoResultText>
      </Container>
    )
  }

  return (
    <Container>
      {suggestions.map((suggestion, i) => {
        const { icon, item, label } = suggestion
        const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
          e.stopPropagation()
          onSelect(item)
        }
        return (
          <Item key={i} onClick={onClick}>
            {icon && <MarkedContainer>{icon}</MarkedContainer>}
            <NameWrapper>
              <NameText>
                {label}
                {/* <PlaceSpan> {place}</PlaceSpan> */}
              </NameText>
            </NameWrapper>
          </Item>
        )
      })}
    </Container>
  )
}

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const MarkedContainer = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: auto;
`

const Container = styled.div`
  width: 100%;
  max-height: 100%;
  overflow: scroll;
  overflow-x: hidden;
  margin: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`

const NoResultText = styled.span`
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  color: ${({ theme }) => theme.color.suggestionPlace};
  text-align: center;
`

const Item = styled.div`
  min-height: 30px;
  max-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 11px;
  cursor: pointer;
`

const NameWrapper = styled.div`
  overflow: hidden;
  min-width: 0;
  min-height: 0;
`

const NameText = styled.p`
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-grow: 1;
`

export default Dropdown
